import { TAudienceCombinationType } from '@definitions/states';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { PropsWithChildren } from 'react';
import { colors, SelectInput, SelectOption } from 'common-components';

type TreeWrapperPropsType = {
  defaultCombination: TAudienceCombinationType
  contentLength: number
  onSelectChange: (value: TAudienceCombinationType, groupIdx?: number) => void
  groupIdx?: number
  disabled?: boolean
};

const VerticalBranch = styled.div`
  position: relative;
  height: auto;
  width: 1.5px;
  border-right: 1px solid ${colors.gray200};
  margin: 24px 0 24px 22px;
`;

const LeavesWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const optionValues: TAudienceCombinationType[] = [10, 20];

const TreeWrapper = ({
  defaultCombination,
  contentLength,
  onSelectChange,
  groupIdx,
  disabled,
  children,
}: PropsWithChildren<TreeWrapperPropsType>) => {
  const { translate } = useAppTranslation();

  const selectClassOverride = css`
    position: absolute;
    top: calc(50% - 11px);
    left: -25px;
    width: 50px !important;
    --ant-select-height: 22px !important;
    --ant-select-font-size: 12px !important;
    --ant-select-font-height: 18px !important;
    --ant-select-padding-horizontal: 6px !important;
    --ant-select-background-color: ${colors.gray50} !important;
    font-weight: 500;

    .ant-select-content {
      margin-inline-end: 0 !important;
    }

    .ant-select-content-value {
      padding: 0 !important;
      min-height: 0 !important;
    }

    .ant-select-suffix {
      font-size: 10px !important;
    }
  `;

  const disabledCss = css`
    pointer-events: none;
    opacity: 0.6;
    --ant-select-background-color: ${colors.gray100} !important;
  `;

  return (
    <div style={{ display: 'flex' }}>
      {contentLength > 1 && (
        <VerticalBranch>
          <SelectInput
            css={[selectClassOverride, disabled && disabledCss]}
            defaultValue={defaultCombination}
            onChange={(value) => {
              if (!disabled) {
                onSelectChange(value, groupIdx);
              }
            }}
          >
            {optionValues.map((option) => (
              <SelectOption
                key={option}
                value={option}
                style={{
                  padding: 5,
                  fontSize: 12,
                  fontWeight: 500,
                  minHeight: 22,
                }}
              >
                {translate(`project.audience.select.${option}`)}
              </SelectOption>
            ))}
          </SelectInput>
        </VerticalBranch>
      )}
      <LeavesWrapper>{children}</LeavesWrapper>
    </div>
  );
};

export default TreeWrapper;
